/* eslint-disable react/no-unknown-property,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SidebarGrid, HamBurgerContainer, MainSideBarLinks, Navigation, StyledLink, StyledSvg, SidebarCard } from './style';
import { uploadProfile, getRewardPoints, getCompanyBrandingDetails } from '../../redux/actions';
import Loading from '../Loading';
import { withTranslation } from 'react-i18next';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import Waiting from '../Waiting';
import {  AdminBillingIcon, AdminDashboardIcon, AdminIntegrationsIcon, AdminPeopleIcon, AdminRecognitionIcon, AdminSurveysIcon, HealthDataIcon, UserChallengeIcon, UserCommunityIcon, UserDashboardIcon, UserEventsIcon, UserLeaderBoardIcon, UserRewardsIcon, UserSettingsIcon, UserSocialFeedIcon, UserWellnessIcon } from '../../utils/icons';

const companyNavigationArray = [
  {
    name: 'Dashboard',
    id: 'company-dashboard-nav',
    active: 'dashboard',
    route: '/company/dashboard',
    width: '18px',
    height: '20px',
    svg: "M11.4993 17.8034H15.2911C16.2306 17.8034 16.9969 17.0711 16.9969 16.1759V6.53716C16.9969 6.30851 16.8953 6.09092 16.7178 5.93644C12.2201 1.99721 9.45324 0 8.50041 0C7.54406 0 4.77534 1.99721 0.278427 5.93624C0.100341 6.09072 0 6.30831 0 6.53697V16.1757C0 17.0711 0.765622 17.8034 1.70435 17.8034H5.49535C5.9697 17.8034 6.35427 17.4359 6.35427 16.9853V12.4518C6.35427 11.3264 7.31643 10.4068 8.50041 10.4068C9.68005 10.4068 10.6416 11.3265 10.6416 12.4518V16.9853C10.6416 17.4361 11.0268 17.8034 11.4993 17.8034ZM1.71638 16.1755V6.89894C4.41088 4.554 7.61559 2.01323 8.50021 1.65996C9.38027 2.01323 12.5827 4.554 15.2807 6.89894V16.1658H12.3561V12.4518C12.3561 10.425 10.6258 8.77193 8.50041 8.77193C6.36857 8.77193 4.63602 10.425 4.63602 12.4518V16.1668L1.71638 16.1755Z",
    value: "dashboard"
  },
  // {
  //   name: 'People',
  //   id: 'company-people-nav',
  //   active: 'people',
  //   route: '/company/people',
  //   width: '26px',
  //   height: '18px',
  //   svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
  //   value: "people"
  // },
  // {
  //   name: 'Reports',
  //   id: 'company-people-nav',
  //   active: 'reports',
  //   route: '/company/reports',
  //   width: '20px',
  //   height: '21px',
  //   svg: 'M10.92 2.25L9.65 2.25C9.41 1.52 8.76 1 8 1C7.24 1 6.59 1.52 6.35 2.25L5.08 2.25C4.76 2.25 4.5 2.53 4.5 2.87L4.5 5.37C4.5 5.72 4.76 6 5.08 6L10.92 6C11.24 6 11.5 5.72 11.5 5.37L11.5 2.87C11.5 2.53 11.24 2.25 10.92 2.25ZM13.83 3.5L12.67 3.5L12.67 5.37C12.67 6.41 11.88 7.25 10.92 7.25L5.08 7.25C4.12 7.25 3.33 6.41 3.33 5.37L3.33 3.5L2.17 3.5C1.52 3.5 1 4.06 1 4.75L1 19.75C1 20.45 1.51 21 2.17 21L13.83 21C14.49 21 15 20.45 15 19.75L15 4.75C15 4.05 14.49 3.5 13.83 3.5ZM7.83 14.57L5.5 17.07C5.38 17.19 5.23 17.25 5.08 17.25C4.93 17.25 4.78 17.19 4.67 17.07L3.5 15.82C3.28 15.57 3.28 15.18 3.5 14.93C3.73 14.69 4.1 14.69 4.33 14.93L5.08 15.74L7 13.68C7.23 13.44 7.6 13.44 7.83 13.68C8.06 13.93 8.06 14.32 7.83 14.57ZM7.83 9.57L5.5 12.07C5.38 12.19 5.23 12.25 5.08 12.25C4.93 12.25 4.78 12.19 4.67 12.07L3.5 10.82C3.28 10.57 3.28 10.18 3.5 9.93C3.73 9.69 4.1 9.69 4.33 9.93L5.08 10.74L7 8.68C7.23 8.44 7.6 8.44 7.83 8.68C8.06 8.93 8.06 9.32 7.83 9.57ZM12.08 16L9.75 16C9.43 16 9.17 15.72 9.17 15.37C9.17 15.03 9.43 14.75 9.75 14.75L12.08 14.75C12.41 14.75 12.67 15.03 12.67 15.37C12.67 15.72 12.41 16 12.08 16ZM12.08 11L9.75 11C9.43 11 9.17 10.72 9.17 10.37C9.17 10.03 9.43 9.75 9.75 9.75L12.08 9.75C12.41 9.75 12.67 10.03 12.67 10.37C12.67 10.72 12.41 11 12.08 11Z',
  //   padding: '0px 0px 0px 5px',
  //   condition: true,
  //   value: "reports"
  // }
];

// {
//   name: 'Events',
//   id: 'company-events-nav',
//   active: 'events',
//   route: '/company/events',
//   width: '23px',
//   height: '21px',
//   value: "company-events"
// },

class SideBarV3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: 'Training Amigo',
      totalPoints: 80,
      showSideBarMenu: false,
      imgSrc: '',
      hide: false,
      colorInfo: this.props.colorInfo2,
      hoverState: null,
      hoverStateAdmin: null
    };
  }

  getSideTabStatus = (route) => {
    let findIndex = companyNavigationArray.findIndex((data) => data.route === route);
    return findIndex === -1;
  }
  componentDidMount() {
    const {  role, hideTab, userCompany, fetchCompanyBrandingDetails } = this.props;
    userCompany === null ? fetchCompanyBrandingDetails(1) : fetchCompanyBrandingDetails(userCompany.id);
  
    if( this.props.colorInfo2?.company_branding?.show_challenge && this.getSideTabStatus('/company/challenges')) {
      companyNavigationArray.splice(2,0,{
        name: 'Challenges',
        id: 'company-challenges-nav',
        active: 'challenges',
        route: '/company/challenges',
        width: '26px',
        height: '18px',
        svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
        value: "challenges" 
      })}

    if( this.props.colorInfo2?.company_branding?.show_employee_directory && this.getSideTabStatus('/company/people')) {
      companyNavigationArray.splice(1,0,
        {
          name: 'People',
          id: 'company-people-nav',
          active: 'people',
          route: '/company/people',
          width: '26px',
          height: '18px',
          svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
          value: "people"
        })}



    if(this.getSideTabStatus('/company/events') && ( this.props.colorInfo2?.company_branding?.show_events)){
        
      companyNavigationArray.splice(4, 0, 
        {
          name: 'Events',
          id: 'company-events-nav',
          active: 'events',
          route: '/company/events',
          width: '23px',
          height: '21px',
          value: "company-events"
        },
      );
    }

    if(this.getSideTabStatus('/company/health') && (this.props?.colorInfo2?.company_branding?.show_biometric)){
        
      companyNavigationArray.splice(4, 0, 
        {
          name: 'Health Data',
          id: 'company-people-nav',
          active: 'health',
          route: '/company/health',
          width: '20px',
          height: '21px',
          svg: 'M10.92 2.25L9.65 2.25C9.41 1.52 8.76 1 8 1C7.24 1 6.59 1.52 6.35 2.25L5.08 2.25C4.76 2.25 4.5 2.53 4.5 2.87L4.5 5.37C4.5 5.72 4.76 6 5.08 6L10.92 6C11.24 6 11.5 5.72 11.5 5.37L11.5 2.87C11.5 2.53 11.24 2.25 10.92 2.25ZM13.83 3.5L12.67 3.5L12.67 5.37C12.67 6.41 11.88 7.25 10.92 7.25L5.08 7.25C4.12 7.25 3.33 6.41 3.33 5.37L3.33 3.5L2.17 3.5C1.52 3.5 1 4.06 1 4.75L1 19.75C1 20.45 1.51 21 2.17 21L13.83 21C14.49 21 15 20.45 15 19.75L15 4.75C15 4.05 14.49 3.5 13.83 3.5ZM7.83 14.57L5.5 17.07C5.38 17.19 5.23 17.25 5.08 17.25C4.93 17.25 4.78 17.19 4.67 17.07L3.5 15.82C3.28 15.57 3.28 15.18 3.5 14.93C3.73 14.69 4.1 14.69 4.33 14.93L5.08 15.74L7 13.68C7.23 13.44 7.6 13.44 7.83 13.68C8.06 13.93 8.06 14.32 7.83 14.57ZM7.83 9.57L5.5 12.07C5.38 12.19 5.23 12.25 5.08 12.25C4.93 12.25 4.78 12.19 4.67 12.07L3.5 10.82C3.28 10.57 3.28 10.18 3.5 9.93C3.73 9.69 4.1 9.69 4.33 9.93L5.08 10.74L7 8.68C7.23 8.44 7.6 8.44 7.83 8.68C8.06 8.93 8.06 9.32 7.83 9.57ZM12.08 16L9.75 16C9.43 16 9.17 15.72 9.17 15.37C9.17 15.03 9.43 14.75 9.75 14.75L12.08 14.75C12.41 14.75 12.67 15.03 12.67 15.37C12.67 15.72 12.41 16 12.08 16ZM12.08 11L9.75 11C9.43 11 9.17 10.72 9.17 10.37C9.17 10.03 9.43 9.75 9.75 9.75L12.08 9.75C12.41 9.75 12.67 10.03 12.67 10.37C12.67 10.72 12.41 11 12.08 11Z',
          padding: '0px 0px 0px 5px',
          condition: true,
          value: "health"
        }
      );
    }

    if(this.getSideTabStatus('/company/wellness') && (this.props.colorInfo2?.company_branding?.show_education)){
      companyNavigationArray.splice(4, 0,
        {
          name: 'Wellness',
          id: 'company-wellness-nav',
          active: 'wellness',
          route: '/company/wellness',
          width: '23px',
          height: '21px',
          value: "company-wellness"
        },
      );
    }
     
    if (role === 'ADMIN') {      
      let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/admin');
      if (findIndex === -1) {
        companyNavigationArray.unshift({
          name: 'Admin Panel',
          id: 'admin-panel-nav',
          active: 'admin',
          route: '/company/admin',
          width: '18px',
          height: '20px',
          svg: "M11.4993 17.8034H15.2911C16.2306 17.8034 16.9969 17.0711 16.9969 16.1759V6.53716C16.9969 6.30851 16.8953 6.09092 16.7178 5.93644C12.2201 1.99721 9.45324 0 8.50041 0C7.54406 0 4.77534 1.99721 0.278427 5.93624C0.100341 6.09072 0 6.30831 0 6.53697V16.1757C0 17.0711 0.765622 17.8034 1.70435 17.8034H5.49535C5.9697 17.8034 6.35427 17.4359 6.35427 16.9853V12.4518C6.35427 11.3264 7.31643 10.4068 8.50041 10.4068C9.68005 10.4068 10.6416 11.3265 10.6416 12.4518V16.9853C10.6416 17.4361 11.0268 17.8034 11.4993 17.8034ZM1.71638 16.1755V6.89894C4.41088 4.554 7.61559 2.01323 8.50021 1.65996C9.38027 2.01323 12.5827 4.554 15.2807 6.89894V16.1658H12.3561V12.4518C12.3561 10.425 10.6258 8.77193 8.50041 8.77193C6.36857 8.77193 4.63602 10.425 4.63602 12.4518V16.1668L1.71638 16.1755Z",
          value: "adminPanel"
        })
      }
      if(role=="ADMIN" && this.getSideTabStatus('/company/challenges')) {
        companyNavigationArray.splice(3,0,{
          name: 'Challenges',
          id: 'company-challenges-nav',
          active: 'challenges',
          route: '/company/challenges',
          width: '26px',
          height: '18px',
          svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
          value: "challenges" 
        })}

      if(role=="ADMIN" && this.getSideTabStatus('/company/rewards-management') && this.props.colorInfo2?.company_branding?.company_rewards ){
        let findIndex = companyNavigationArray.findIndex((data)=> data.route == '/company/rewards-management');

        if(findIndex == -1){
          companyNavigationArray.splice(4, 0, 
            {
              name: 'Rewards',
              id: 'company-rewards-nav',
              active: 'rewards',
              route: '/company/rewards-management',
              width: '23px',
              height: '21px',
              value: "rewards-points-management"
            },
          );
        }
      }

      if (this.getSideTabStatus('/company/biometric') && this.getSideTabStatus('/company/recognition') && this.getSideTabStatus('/company/surveys') && this.getSideTabStatus('/company/monthly_tasks')) {
        companyNavigationArray.push({
        //   {
        //   name: 'Biometric',
        //   id: 'company-people-nav',
        //   active: 'biometric',
        //   route: '/company/biometric',
        //   width: '26px',
        //   height: '18px',
        //   svg: 'M10.92 2.25L9.65 2.25C9.41 1.52 8.76 1 8 1C7.24 1 6.59 1.52 6.35 2.25L5.08 2.25C4.76 2.25 4.5 2.53 4.5 2.87L4.5 5.37C4.5 5.72 4.76 6 5.08 6L10.92 6C11.24 6 11.5 5.72 11.5 5.37L11.5 2.87C11.5 2.53 11.24 2.25 10.92 2.25ZM13.83 3.5L12.67 3.5L12.67 5.37C12.67 6.41 11.88 7.25 10.92 7.25L5.08 7.25C4.12 7.25 3.33 6.41 3.33 5.37L3.33 3.5L2.17 3.5C1.52 3.5 1 4.06 1 4.75L1 19.75C1 20.45 1.51 21 2.17 21L13.83 21C14.49 21 15 20.45 15 19.75L15 4.75C15 4.05 14.49 3.5 13.83 3.5ZM7.83 14.57L5.5 17.07C5.38 17.19 5.23 17.25 5.08 17.25C4.93 17.25 4.78 17.19 4.67 17.07L3.5 15.82C3.28 15.57 3.28 15.18 3.5 14.93C3.73 14.69 4.1 14.69 4.33 14.93L5.08 15.74L7 13.68C7.23 13.44 7.6 13.44 7.83 13.68C8.06 13.93 8.06 14.32 7.83 14.57ZM7.83 9.57L5.5 12.07C5.38 12.19 5.23 12.25 5.08 12.25C4.93 12.25 4.78 12.19 4.67 12.07L3.5 10.82C3.28 10.57 3.28 10.18 3.5 9.93C3.73 9.69 4.1 9.69 4.33 9.93L5.08 10.74L7 8.68C7.23 8.44 7.6 8.44 7.83 8.68C8.06 8.93 8.06 9.32 7.83 9.57ZM12.08 16L9.75 16C9.43 16 9.17 15.72 9.17 15.37C9.17 15.03 9.43 14.75 9.75 14.75L12.08 14.75C12.41 14.75 12.67 15.03 12.67 15.37C12.67 15.72 12.41 16 12.08 16ZM12.08 11L9.75 11C9.43 11 9.17 10.72 9.17 10.37C9.17 10.03 9.43 9.75 9.75 9.75L12.08 9.75C12.41 9.75 12.67 10.03 12.67 10.37C12.67 10.72 12.41 11 12.08 11Z',
        //   padding: '0px 0px 0px 5px',
        //   value: "biometric"
        // },
        // {
          name: 'Recognition',
          id: 'company-recognition-nav',
          active: 'recognition',
          route: '/company/recognition',
          width: '20px',
          height: '21px',
          svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
          padding: '0px 0px 0px 5px',
          value: "recognition"
        },
        {
          name: 'Surveys',
          id: 'company-surveys-nav',
          active: 'survey',
          route: '/company/surveys',
          width: '23px',
          height: '21px',
          padding: '0px 0px 0px 5px',
          svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
          value: "survey"
        },
        // {
        //   name: 'Monthly Tasks',
        //   id: 'company-monthly_tasks-nav',
        //   active: 'monthly_tasks',
        //   route: '/company/monthly_tasks',
        //   width: '24px',
        //   height: '21px',
        //   padding: '0px 0px 0px 5px',
        //   value: "monthlyTasks"
        // }
        )
      }
    }
    if (role !== 'ADMIN') {
      // if (hideTab && hideTab.company_branding && hideTab.company_branding.show_biometric && role !== 'ADMIN') {
      //   let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/biometric');
      //   if (findIndex === -1) {
      //     companyNavigationArray.push({
      //       name: 'Biometric',
      //       id: 'company-people-nav',
      //       active: 'biometric',
      //       route: '/company/biometric',
      //       width: '20px',
      //       height: '21px',
      //       svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
      //       padding: '0px 0px 0px 5px',
      //       value: "biometric",
      //     })
      //   }
      // }

      if (hideTab && hideTab.company_branding && hideTab.company_branding.show_survey) {
        let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/surveys');
        if (findIndex === -1) {
          companyNavigationArray.push({
            name: 'Surveys',
            id: 'company-surveys-nav',
            active: 'survey',
            route: '/company/surveys',
            width: '23px',
            height: '21px',
            padding: '0px 0px 0px 5px',
            svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
            value: "survey"
          })
        }
      }

      if (hideTab && hideTab.company_branding && hideTab.company_branding.show_recognition) {
        let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/recognition');
        if (findIndex === -1) {
          companyNavigationArray.push({
            name: 'Recognition',
            id: 'company-recognition-nav',
            active: 'recognition',
            route: '/company/recognition',
            width: '20px',
            height: '21px',
            svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
            padding: '0px 0px 0px 5px',
            value: "recognition"
          })
        }
      }

      // if (hideTab && hideTab.company_branding && hideTab.company_branding.show_monthly_task) {
      //   let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/monthly_tasks');
      //   if (findIndex === -1) {
      //     companyNavigationArray.push({
      //       name: 'Monthly Tasks',
      //       id: 'company-monthly_tasks-nav',
      //       active: 'monthly_tasks',
      //       route: '/company/monthly_tasks',
      //       width: '24px',
      //       height: '21px',
      //       padding: '0px 0px 0px 5px',
      //       value: "monthlyTasks"
      //     })
      //   }
      // }
    }

    let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/hris-integration');
    if (findIndex !== -1) {
      // If present, remove it from the current position
      const [existingItem] = companyNavigationArray.splice(findIndex, 1);
      // Push it to the end of the array
      companyNavigationArray.push(existingItem);
    } else {
      // If not present, add the new item to the end of the array
      companyNavigationArray.push({
        name: 'Integrations',
        id: 'company-hris-nav',
        active: '/hris',
        route: '/company/hris-integration',
        width: '30px',
        height: '30px',
        value: "hris",
      });
    }

  }

  componentDidUpdate(prevProps) {
    const { hideTab ,/*role*/  } = this.props;
    if (prevProps.hideTab !== hideTab) {

      
      if(this.props.colorInfo2?.company_branding?.show_challenge && this.getSideTabStatus('/company/challenges')) {
        companyNavigationArray.splice(2,0,{
          name: 'Challenges',
          id: 'company-challenges-nav',
          active: 'challenges',
          route: '/company/challenges',
          width: '26px',
          height: '18px',
          svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
          value: "challenges" 
        })}

      if(this.getSideTabStatus('/company/health') && (this.props?.colorInfo2?.company_branding?.show_biometric)){
      
        companyNavigationArray.splice(4, 0, 
          {
            name: 'Health Data',
            id: 'company-people-nav',
            active: 'health',
            route: '/company/health',
            width: '20px',
            height: '21px',
            svg: 'M10.92 2.25L9.65 2.25C9.41 1.52 8.76 1 8 1C7.24 1 6.59 1.52 6.35 2.25L5.08 2.25C4.76 2.25 4.5 2.53 4.5 2.87L4.5 5.37C4.5 5.72 4.76 6 5.08 6L10.92 6C11.24 6 11.5 5.72 11.5 5.37L11.5 2.87C11.5 2.53 11.24 2.25 10.92 2.25ZM13.83 3.5L12.67 3.5L12.67 5.37C12.67 6.41 11.88 7.25 10.92 7.25L5.08 7.25C4.12 7.25 3.33 6.41 3.33 5.37L3.33 3.5L2.17 3.5C1.52 3.5 1 4.06 1 4.75L1 19.75C1 20.45 1.51 21 2.17 21L13.83 21C14.49 21 15 20.45 15 19.75L15 4.75C15 4.05 14.49 3.5 13.83 3.5ZM7.83 14.57L5.5 17.07C5.38 17.19 5.23 17.25 5.08 17.25C4.93 17.25 4.78 17.19 4.67 17.07L3.5 15.82C3.28 15.57 3.28 15.18 3.5 14.93C3.73 14.69 4.1 14.69 4.33 14.93L5.08 15.74L7 13.68C7.23 13.44 7.6 13.44 7.83 13.68C8.06 13.93 8.06 14.32 7.83 14.57ZM7.83 9.57L5.5 12.07C5.38 12.19 5.23 12.25 5.08 12.25C4.93 12.25 4.78 12.19 4.67 12.07L3.5 10.82C3.28 10.57 3.28 10.18 3.5 9.93C3.73 9.69 4.1 9.69 4.33 9.93L5.08 10.74L7 8.68C7.23 8.44 7.6 8.44 7.83 8.68C8.06 8.93 8.06 9.32 7.83 9.57ZM12.08 16L9.75 16C9.43 16 9.17 15.72 9.17 15.37C9.17 15.03 9.43 14.75 9.75 14.75L12.08 14.75C12.41 14.75 12.67 15.03 12.67 15.37C12.67 15.72 12.41 16 12.08 16ZM12.08 11L9.75 11C9.43 11 9.17 10.72 9.17 10.37C9.17 10.03 9.43 9.75 9.75 9.75L12.08 9.75C12.41 9.75 12.67 10.03 12.67 10.37C12.67 10.72 12.41 11 12.08 11Z',
            padding: '0px 0px 0px 5px',
            condition: true,
            value: "health"
          }
        );
      }

      if( this.props.colorInfo2?.company_branding?.show_employee_directory && this.getSideTabStatus('/company/people')) {
        companyNavigationArray.splice(1,0,
          {
            name: 'People',
            id: 'company-people-nav',
            active: 'people',
            route: '/company/people',
            width: '26px',
            height: '18px',
            svg: "M9.58967 13C9.09608 11.0648 7.41788 9.70567 5.49993 9.70567C3.58198 9.70567 1.90377 11.0648 1.41019 13L0.0422363 12.6159C0.705057 10.0307 2.94736 8.22839 5.49993 8.22839C8.05249 8.22839 10.2948 10.0307 10.9576 12.6159L9.58967 13Z",
            value: "people"
          })}

      if(this.getSideTabStatus('/company/events') && (this.props?.colorInfo2?.company_branding?.show_events)){
          
        companyNavigationArray.splice(4, 0, 
          {
            name: 'Events',
            id: 'company-events-nav',
            active: 'events',
            route: '/company/events',
            width: '23px',
            height: '21px',
            value: "company-events"
          },
        );
      }
      if(this.getSideTabStatus('/company/wellness') && (this.props?.colorInfo2?.company_branding?.show_education)){
        companyNavigationArray.splice(4, 0,
          {
            name: 'Wellness',
            id: 'company-wellness-nav',
            active: 'wellness',
            route: '/company/wellness',
            width: '23px',
            height: '21px',
            value: "company-wellness"
          },
        );
      }
      // if (hideTab && hideTab.company_branding && hideTab.company_branding.show_biometric && role !== 'ADMIN') {
      //   let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/biometric');
      //   if (findIndex === -1) {
      //     companyNavigationArray.push({
      //       name: 'Biometric',
      //       id: 'company-people-nav',
      //       active: 'biometric',
      //       route: '/company/biometric',
      //       width: '26px',
      //       height: '18px',
      //       svg: 'M10.92 2.25L9.65 2.25C9.41 1.52 8.76 1 8 1C7.24 1 6.59 1.52 6.35 2.25L5.08 2.25C4.76 2.25 4.5 2.53 4.5 2.87L4.5 5.37C4.5 5.72 4.76 6 5.08 6L10.92 6C11.24 6 11.5 5.72 11.5 5.37L11.5 2.87C11.5 2.53 11.24 2.25 10.92 2.25ZM13.83 3.5L12.67 3.5L12.67 5.37C12.67 6.41 11.88 7.25 10.92 7.25L5.08 7.25C4.12 7.25 3.33 6.41 3.33 5.37L3.33 3.5L2.17 3.5C1.52 3.5 1 4.06 1 4.75L1 19.75C1 20.45 1.51 21 2.17 21L13.83 21C14.49 21 15 20.45 15 19.75L15 4.75C15 4.05 14.49 3.5 13.83 3.5ZM7.83 14.57L5.5 17.07C5.38 17.19 5.23 17.25 5.08 17.25C4.93 17.25 4.78 17.19 4.67 17.07L3.5 15.82C3.28 15.57 3.28 15.18 3.5 14.93C3.73 14.69 4.1 14.69 4.33 14.93L5.08 15.74L7 13.68C7.23 13.44 7.6 13.44 7.83 13.68C8.06 13.93 8.06 14.32 7.83 14.57ZM7.83 9.57L5.5 12.07C5.38 12.19 5.23 12.25 5.08 12.25C4.93 12.25 4.78 12.19 4.67 12.07L3.5 10.82C3.28 10.57 3.28 10.18 3.5 9.93C3.73 9.69 4.1 9.69 4.33 9.93L5.08 10.74L7 8.68C7.23 8.44 7.6 8.44 7.83 8.68C8.06 8.93 8.06 9.32 7.83 9.57ZM12.08 16L9.75 16C9.43 16 9.17 15.72 9.17 15.37C9.17 15.03 9.43 14.75 9.75 14.75L12.08 14.75C12.41 14.75 12.67 15.03 12.67 15.37C12.67 15.72 12.41 16 12.08 16ZM12.08 11L9.75 11C9.43 11 9.17 10.72 9.17 10.37C9.17 10.03 9.43 9.75 9.75 9.75L12.08 9.75C12.41 9.75 12.67 10.03 12.67 10.37C12.67 10.72 12.41 11 12.08 11Z',
      //       padding: '0px 0px 0px 5px',
      //       value: "biometric"
      //     })
      //   }
      // }

      if (hideTab && hideTab.company_branding && hideTab.company_branding.show_recognition) {
        let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/recognition');
        if (findIndex === -1) {
          companyNavigationArray.push({
            name: 'Recognition',
            id: 'company-recognition-nav',
            active: 'recognition',
            route: '/company/recognition',
            width: '20px',
            height: '21px',
            svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
            padding: '0px 0px 0px 5px',
            value: "recognition"
          })
        }
      }

      if (hideTab && hideTab.company_branding && hideTab.company_branding.show_survey) {
        let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/surveys');
        if (findIndex === -1) {
          companyNavigationArray.push({
            name: 'Surveys',
            id: 'company-surveys-nav',
            active: 'survey',
            route: '/company/surveys',
            width: '23px',
            height: '21px',
            padding: '0px 0px 0px 5px',
            svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
            value: "surveys"
          })
        }
      }

      // if (hideTab && hideTab.company_branding && hideTab.company_branding.show_monthly_task) {
      //   let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/monthly_tasks');
      //   if (findIndex === -1) {
      //     companyNavigationArray.push({
      //       name: 'Monthly Tasks',
      //       id: 'company-monthly_tasks-nav',
      //       active: 'monthly_tasks',
      //       route: '/company/monthly_tasks',
      //       width: '24px',
      //       height: '21px',
      //       padding: '0px 0px 0px 5px',
      //       value: "monthlyTasks"
      //     })
      //   }
      // }
    }
    const { billingTabStatus } = this.props;
    if ((prevProps.billingTabStatus !== billingTabStatus) && billingTabStatus) {
      let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/billing');
      if (findIndex === -1) {
        companyNavigationArray.push({
          name: 'Billing',
          id: 'company-billing-nav',
          active: 'billing',
          route: '/company/billing',
          width: '23px',
          height: '21px',
          padding: '2px 0px 0px 3px',
          svg: 'M11.9747 0.198486H3.0097L3.0097 0.198495H2.75656L2.75061 0.467422L2.74982 0.503327L2.74963 0.511752C2.7375 1.06472 2.72579 1.59843 2.71784 2.11653C2.67524 4.8948 2.74497 7.09583 3.45734 8.60918C4.19381 10.1736 5.57565 10.9859 8.13967 10.9071C13.7719 10.734 12.25 0.55394 12.2319 0.433082L12.2317 0.432061L12.1976 0.198486H11.9747ZM10.0715 2.42038C10.1775 2.3186 10.3418 2.32675 10.4383 2.43858L10.4384 2.43872C10.4519 2.45408 11.5743 3.73205 10.5426 5.75251C10.4747 5.88565 10.3173 5.93554 10.1911 5.86394C10.0648 5.79235 10.0175 5.62637 10.0854 5.49324C10.9418 3.81606 10.0644 2.81874 10.0543 2.80726L10.0542 2.80717C9.95771 2.69534 9.96544 2.52215 10.0715 2.42038Z',
          value: "billing"
        })
      }
    }

    let findIndex = companyNavigationArray.findIndex((data) => data.route === '/company/hris-integration');
    if (findIndex !== -1) {
      // If present, remove it from the current position
      const [existingItem] = companyNavigationArray.splice(findIndex, 1);
      // Push it to the end of the array
      companyNavigationArray.push(existingItem);
    } else {
      // If not present, add the new item to the end of the array
      companyNavigationArray.push({
        name: 'Integrations',
        id: 'company-hris-nav',
        active: '/hris',
        route: '/company/hris-integration',
        width: '30px',
        height: '30px',
        value: "hris",
      });
    }

    if (prevProps.colorInfo2 !== this.props.colorInfo2) {
      this.setState({ colorInfo: this.props.colorInfo2 });
    }

    if(this.getSideTabStatus('/company/rewards-management') && this.props.colorInfo2?.company_branding?.company_rewards){
      let findIndex = companyNavigationArray.findIndex((data)=> data.route == '/company/rewards-management');

      if(findIndex == -1){
        companyNavigationArray.splice(4, 0, 
          {
            name: 'Rewards',
            id: 'company-rewards-nav',
            active: 'rewards',
            route: '/company/rewards-management',
            width: '23px',
            height: '21px',
            value: "rewards-points-management"
          },
        );
      }
    }
  }


  showSideBarMenuOptions = () => {
    this.setState((prev) => ({
      showSideBarMenu: !prev.showSideBarMenu
    }))
  };

  renderNavigation = (currentLocation, getColor, hideContent, colorInfo,sideBarIconColor) => (
    <div>
      {
        currentLocation.includes('company') ? this.renderCompanyNavigation(currentLocation, getColor, hideContent, colorInfo,sideBarIconColor) :
          this.renderCommonNavigation(currentLocation, getColor, hideContent,sideBarIconColor)
      }
    </div>
  );

  changeRoute = (value) => {
    const { history } = this.props;
    this.setState({
      showSideBarMenu: false
    });
    history.push(value);
  };


  renderCompanyNavigation = (CurrentLocation, getColor, hideContent, colorInfo,sideBarIconColor) => (
    <Navigation>
      {companyNavigationArray.map((navigator, index) => (
        navigator.condition ?
          (this.props.role === 'ADMIN' || this.props.role === 'WELLNESS_ADMIN') &&
          (<li id={navigator.id} key={index}>
            <StyledLink commonDashboard onClick={() => this.changeRoute(navigator.route)} onMouseEnter={() => this.showCardAdmin(navigator.value)} onMouseLeave={() => this.hideCardAdmin()}
              active={CurrentLocation.includes(navigator.active) ? 1 : 0}
              bgColor={getColor ? this.hexToRGBA(getColor, 0.1) : ''}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}
              width={"0px"} bottom={"0px"} left={"100px"} color={getColor ? getColor : "#0D4270"}
            >
              <span className="iconLinkContainer">
                <div>{HealthDataIcon(sideBarIconColor)}</div>
                {hideContent ? null : <span>{navigator.name}</span>}
              </span>
              {hideContent && (this.state.hoverStateAdmin === navigator.value) ? <SidebarCard  width="0px" bottom="0px" left="100px" commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t(navigator.name)}</div></SidebarCard> : null}
              <div dashboard={1} />
            </StyledLink>
          </li>
          )
          :
          (
            <li id={navigator.id} key={index}>
              <StyledLink commonDashboard onClick={() => this.changeRoute(navigator.route)} onMouseEnter={() => this.showCardAdmin(navigator.value)} onMouseLeave={() => this.hideCardAdmin()}
                active={CurrentLocation.includes(navigator.active) ? 1 : 0}
                bgColor={getColor ? this.hexToRGBA(getColor, 0.1) : ''}
                colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
                <span className="iconLinkContainer">
                  {
                    navigator.name === 'Admin Panel' ?
                      <svg className="sc-iQtOjA dGlpBQ" width="22" height="22" viewBox="0 0 16 18" fill="none">
                        <path
                          d="M13.6875 17H11.5C10.7751 17 10.1875 16.4344 10.1875 15.7367V11.9469H5.8125V15.7367C5.8125 16.4344 5.22488 17 4.5 17H2.31251C1.58763 17 1.00001 16.4344 1.00001 15.7367V7.64763C0.998858 7.3276 1.12395 7.01909 1.35001 6.7844L7.7025 1.11234C7.8703 0.962553 8.1297 0.962553 8.2975 1.11234L14.6281 6.76334C14.6353 6.76482 14.6428 6.76482 14.65 6.76334C15 7 15.0011 7.30655 15 7.62658V15.7367C15 16.4344 14.4124 17 13.6875 17Z"
                          stroke="#9C9C9C" />
                      </svg>
                      :
                      navigator.name === 'Dashboard' ?
                        <div>{AdminDashboardIcon(sideBarIconColor)}</div>
                        :
                        navigator.name === 'Recognition' ?
                          <div>{AdminRecognitionIcon(sideBarIconColor)}</div>
                          :
                          navigator.name === 'People' ?
                            <div>{AdminPeopleIcon(sideBarIconColor)}</div> :
                            navigator.name === 'Challenges' ?
                              <div>{UserChallengeIcon(sideBarIconColor)}</div>
                              : colorInfo && colorInfo.company_branding && colorInfo.company_branding.show_biometric && navigator.name === 'Wellbeing'/* || navigator.name === 'Biometric' */ ?
                                CurrentLocation.includes(navigator.active) ?
                                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.882 23H9.5C9.224 23 9 22.776 9 22.5C9 22.224 9.224 22 9.5 22H14.882C15.073 22 15.244 21.894 15.329 21.724L16.377 19.628C16.586 19.209 17.004 18.964 17.475 18.989C17.943 19.014 18.335 19.301 18.499 19.739L20.438 24.909C20.468 24.99 20.531 25.01 20.578 25.012C20.632 25.015 20.69 25.002 20.728 24.925L21.776 22.829C22.032 22.318 22.546 22 23.118 22H27.5C27.776 22 28 22.224 28 22.5C28 22.776 27.776 23 27.5 23H23.118C22.927 23 22.756 23.106 22.671 23.276L21.623 25.372C21.423 25.771 21.031 26.013 20.59 26.013C20.569 26.013 20.547 26.013 20.526 26.011C20.058 25.986 19.666 25.699 19.502 25.261L17.563 20.091C17.533 20.01 17.47 19.99 17.423 19.988C17.374 19.993 17.311 19.999 17.273 20.075L16.225 22.171C15.969 22.682 15.454 23 14.882 23ZM31 17.985V27.5C31 29.981 28.981 32 26.5 32H15.5C13.019 32 11 29.981 11 27.5V25.5C11 25.224 11.224 25 11.5 25C11.776 25 12 25.224 12 25.5V27.5C12 29.43 13.57 31 15.5 31H26.5C28.43 31 30 29.43 30 27.5V17.985C30 17.65 29.962 17.322 29.904 17H24.5C23.122 17 22 15.878 22 14.5V9.096C21.677 9.038 21.349 9 21.015 9H15.5C13.57 9 12 10.57 12 12.5V19.5C12 19.776 11.776 20 11.5 20C11.224 20 11 19.776 11 19.5V12.5C11 10.019 13.019 8 15.5 8H21.015C22.751 8 24.384 8.676 25.611 9.904L29.096 13.389C30.324 14.617 31 16.249 31 17.985ZM29.621 16C29.348 15.296 28.939 14.646 28.39 14.096L24.905 10.611C24.355 10.061 23.705 9.652 23.001 9.38V14.501C23.001 15.328 23.674 16.001 24.501 16.001H29.622L29.621 16Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                  </svg>
                                  :
                                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.882 23H9.5C9.224 23 9 22.776 9 22.5C9 22.224 9.224 22 9.5 22H14.882C15.073 22 15.244 21.894 15.329 21.724L16.377 19.628C16.586 19.209 17.004 18.964 17.475 18.989C17.943 19.014 18.335 19.301 18.499 19.739L20.438 24.909C20.468 24.99 20.531 25.01 20.578 25.012C20.632 25.015 20.69 25.002 20.728 24.925L21.776 22.829C22.032 22.318 22.546 22 23.118 22H27.5C27.776 22 28 22.224 28 22.5C28 22.776 27.776 23 27.5 23H23.118C22.927 23 22.756 23.106 22.671 23.276L21.623 25.372C21.423 25.771 21.031 26.013 20.59 26.013C20.569 26.013 20.547 26.013 20.526 26.011C20.058 25.986 19.666 25.699 19.502 25.261L17.563 20.091C17.533 20.01 17.47 19.99 17.423 19.988C17.374 19.993 17.311 19.999 17.273 20.075L16.225 22.171C15.969 22.682 15.454 23 14.882 23ZM31 17.985V27.5C31 29.981 28.981 32 26.5 32H15.5C13.019 32 11 29.981 11 27.5V25.5C11 25.224 11.224 25 11.5 25C11.776 25 12 25.224 12 25.5V27.5C12 29.43 13.57 31 15.5 31H26.5C28.43 31 30 29.43 30 27.5V17.985C30 17.65 29.962 17.322 29.904 17H24.5C23.122 17 22 15.878 22 14.5V9.096C21.677 9.038 21.349 9 21.015 9H15.5C13.57 9 12 10.57 12 12.5V19.5C12 19.776 11.776 20 11.5 20C11.224 20 11 19.776 11 19.5V12.5C11 10.019 13.019 8 15.5 8H21.015C22.751 8 24.384 8.676 25.611 9.904L29.096 13.389C30.324 14.617 31 16.249 31 17.985ZM29.621 16C29.348 15.296 28.939 14.646 28.39 14.096L24.905 10.611C24.355 10.061 23.705 9.652 23.001 9.38V14.501C23.001 15.328 23.674 16.001 24.501 16.001H29.622L29.621 16Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                  </svg>
                                :
                                navigator.name === 'Rewards' ?
                                  <div>{UserRewardsIcon(sideBarIconColor)}</div>
                                  :
                                  navigator.name === 'Surveys' ?
                                    CurrentLocation.includes(navigator.active) ?
                                      <StyledSvg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32 31.5C32 31.776 31.776 32 31.5 32H12.5C10.019 32 8 29.981 8 27.5V8.5C8 8.224 8.224 8 8.5 8C8.776 8 9 8.224 9 8.5V27.5C9 29.43 10.57 31 12.5 31H31.5C31.776 31 32 31.224 32 31.5ZM26.5 28C26.776 28 27 27.776 27 27.5V14.5C27 14.224 26.776 14 26.5 14C26.224 14 26 14.224 26 14.5V27.5C26 27.776 26.224 28 26.5 28ZM22.5 28C22.776 28 23 27.776 23 27.5V19.5C23 19.224 22.776 19 22.5 19C22.224 19 22 19.224 22 19.5V27.5C22 27.776 22.224 28 22.5 28ZM18.5 28C18.776 28 19 27.776 19 27.5V14.5C19 14.224 18.776 14 18.5 14C18.224 14 18 14.224 18 14.5V27.5C18 27.776 18.224 28 18.5 28ZM14.5 28C14.776 28 15 27.776 15 27.5V19.5C15 19.224 14.776 19 14.5 19C14.224 19 14 19.224 14 19.5V27.5C14 27.776 14.224 28 14.5 28Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                      </StyledSvg>
                                      :
                                      <div>{AdminSurveysIcon(sideBarIconColor)}</div>
                                    : navigator.name === 'Billing' ?
                                      CurrentLocation.includes(navigator.active) ?
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M12.5 16C11.673 16 11 16.673 11 17.5V18.5C11 19.327 11.673 20 12.5 20H17.5C18.327 20 19 19.327 19 18.5V17.5C19 16.673 18.327 16 17.5 16H12.5ZM18 17.5V18.5C18 18.775 17.775 19 17.5 19H12.5C12.225 19 12 18.775 12 18.5V17.5C12 17.225 12.225 17 12.5 17H17.5C17.775 17 18 17.225 18 17.5ZM18 22.5C18 22.776 17.776 23 17.5 23H16.5C16.224 23 16 22.776 16 22.5C16 22.224 16.224 22 16.5 22H17.5C17.776 22 18 22.224 18 22.5ZM18 25.5C18 25.776 17.776 26 17.5 26H16.5C16.224 26 16 25.776 16 25.5C16 25.224 16.224 25 16.5 25H17.5C17.776 25 18 25.224 18 25.5ZM14 22.5C14 22.776 13.776 23 13.5 23H12.5C12.224 23 12 22.776 12 22.5C12 22.224 12.224 22 12.5 22H13.5C13.776 22 14 22.224 14 22.5ZM14 25.5C14 25.776 13.776 26 13.5 26H12.5C12.224 26 12 25.776 12 25.5C12 25.224 12.224 25 12.5 25H13.5C13.776 25 14 25.224 14 25.5ZM18 28.5C18 28.776 17.776 29 17.5 29H16.5C16.224 29 16 28.776 16 28.5C16 28.224 16.224 28 16.5 28H17.5C17.776 28 18 28.224 18 28.5ZM14 28.5C14 28.776 13.776 29 13.5 29H12.5C12.224 29 12 28.776 12 28.5C12 28.224 12.224 28 12.5 28H13.5C13.776 28 14 28.224 14 28.5ZM25.487 8H15.5C12.468 8 10 10.468 10 13.5C10 13.518 10.008 13.533 10.01 13.551C8.815 14.243 8 15.522 8 17V28C8 30.206 9.794 32 12 32H18C20.206 32 22 30.206 22 28V17C22 15.547 21.214 14.286 20.053 13.585C20.503 10.929 22.788 9 25.487 9C28.527 9 31 11.473 31 14.513V23.51L28.964 22.009C28.793 21.881 28.559 21.878 28.382 22.001L25.833 23.772L24.785 23.043C24.559 22.887 24.247 22.94 24.09 23.168C23.932 23.395 23.987 23.706 24.215 23.863L25.548 24.791C25.718 24.91 25.946 24.91 26.118 24.791L28.658 23.025L31.203 24.901C31.291 24.965 31.395 24.999 31.5 24.999C31.577 24.999 31.654 24.981 31.726 24.945C31.894 24.86 32 24.687 32 24.499V14.513C32 10.922 29.078 8 25.487 8ZM21 17V28C21 29.654 19.654 31 18 31H12C10.346 31 9 29.654 9 28V17C9 15.346 10.346 14 12 14H18C19.654 14 21 15.346 21 17ZM19.129 13.182C18.769 13.075 18.395 13 18 13H12C11.666 13 11.347 13.053 11.037 13.13C11.229 10.824 13.145 9 15.5 9H22.035C20.571 9.915 19.5 11.397 19.129 13.182Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                        </svg>
                                        :
                                        <div>{AdminBillingIcon(sideBarIconColor)}</div>
                                      :
                                      /*navigator.name === 'Monthly Tasks' ?
                                        CurrentLocation.includes(navigator.active) ?
                                          <StyledSvg xmlns="http://www.w3.org/2000/svg" width="19" height="24"
                                            viewBox="0 0 19 24" fill="none">
                                            <path
                                              d="M9.42203 10.2649C7.15433 10.2649 5.30945 12.1098 5.30945 14.3775C5.30945 16.6451 7.15433 18.4901 9.42203 18.4901C11.6897 18.4901 13.5346 16.6451 13.5346 14.3775C13.5346 12.1098 11.6897 10.2649 9.42203 10.2649ZM8.75773 16.6921L6.53124 14.4907L7.43759 13.5741L8.79189 14.9131L11.4244 12.5028L12.2949 13.4536L8.75773 16.6921Z"
                                              stroke="#9C9C9C" />
                                            <path
                                              d="M14.1092 2.81128H11.4554L11.3099 2.36754C11.0418 1.54958 10.283 1 9.42199 1C8.56093 1 7.80222 1.54958 7.53405 2.36754L7.3886 2.81128H4.73474V4.95677H14.1092V2.81128Z"
                                              stroke="#9C9C9C" />
                                            <path
                                              d="M15.3983 3.85718V6.24579H3.44563V3.85718H1V22.9999H17.8439V3.85718H15.3983ZM9.42196 19.7791C6.44346 19.7791 4.0203 17.3559 4.0203 14.3774C4.0203 11.399 6.44346 8.97579 9.42196 8.97579C12.4005 8.97579 14.8236 11.399 14.8236 14.3774C14.8236 17.3559 12.4004 19.7791 9.42196 19.7791Z"
                                              stroke="#9C9C9C" />
                                          </StyledSvg>
                                          :
                                          <StyledSvg xmlns="http://www.w3.org/2000/svg" width="19" height="24"
                                            viewBox="0 0 19 24" fill="none">
                                            <path
                                              d="M9.42203 10.2649C7.15433 10.2649 5.30945 12.1098 5.30945 14.3775C5.30945 16.6451 7.15433 18.4901 9.42203 18.4901C11.6897 18.4901 13.5346 16.6451 13.5346 14.3775C13.5346 12.1098 11.6897 10.2649 9.42203 10.2649ZM8.75773 16.6921L6.53124 14.4907L7.43759 13.5741L8.79189 14.9131L11.4244 12.5028L12.2949 13.4536L8.75773 16.6921Z"
                                              stroke="#9C9C9C" />
                                            <path
                                              d="M14.1092 2.81128H11.4554L11.3099 2.36754C11.0418 1.54958 10.283 1 9.42199 1C8.56093 1 7.80222 1.54958 7.53405 2.36754L7.3886 2.81128H4.73474V4.95677H14.1092V2.81128Z"
                                              stroke="#9C9C9C" />
                                            <path
                                              d="M15.3983 3.85718V6.24579H3.44563V3.85718H1V22.9999H17.8439V3.85718H15.3983ZM9.42196 19.7791C6.44346 19.7791 4.0203 17.3559 4.0203 14.3774C4.0203 11.399 6.44346 8.97579 9.42196 8.97579C12.4005 8.97579 14.8236 11.399 14.8236 14.3774C14.8236 17.3559 12.4004 19.7791 9.42196 19.7791Z"
                                              stroke="#9C9C9C" />
                                          </StyledSvg>:*/
                                      navigator.name === 'Integrations' ?
                                        CurrentLocation.includes(navigator.active) ?
                                          <StyledSvg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.79778 8.80137C9.04278 9.55437 8.67578 10.2774 8.67578 11.0094C8.67578 11.9664 9.31578 12.7154 9.79778 13.1964C10.5378 13.9354 11.2678 14.3044 11.9978 14.3044C12.7278 14.3044 13.4578 13.9344 14.1978 13.1964C14.9528 12.4434 15.3198 11.7204 15.3198 10.9884C15.3198 10.0314 14.6798 9.28237 14.1978 8.80137C12.7178 7.32337 11.2778 7.32337 9.79778 8.80137ZM13.4918 12.4894C12.2408 13.7374 11.4498 13.4334 10.5038 12.4894C9.93878 11.9254 9.67578 11.4554 9.67578 11.0104C9.67578 10.5564 9.94678 10.0664 10.5038 9.51037C11.0868 8.92837 11.5688 8.68437 12.0148 8.68437C12.5258 8.68437 12.9868 9.00637 13.4928 9.51037C14.0578 10.0744 14.3208 10.5444 14.3208 10.9894C14.3208 11.4434 14.0488 11.9334 13.4918 12.4894Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                            <path d="M23.0165 10.9475C23.0245 9.35249 22.1995 8.46649 20.4955 8.24749C20.3075 7.85349 20.0785 7.46049 19.8015 7.05949C21.0065 5.60349 21.0115 4.36549 19.8275 3.18349C18.6445 2.00249 17.4025 2.00849 15.9435 3.21249C15.5425 2.93849 15.1495 2.71149 14.7555 2.52449C14.5385 0.818488 13.6215 0.000488281 12.0505 0.000488281C10.4485 0.00848828 9.55553 0.849488 9.32553 2.56949C8.93353 2.75849 8.53453 2.99049 8.13553 3.26049C6.68453 2.06349 5.44153 2.06649 4.24553 3.26049C3.06753 4.43549 3.06553 5.70849 4.24453 7.14249C3.97153 7.54249 3.73853 7.94049 3.54853 8.33149C1.82953 8.56049 0.988526 9.45349 0.980526 11.0525C0.972526 12.6475 1.79753 13.5335 3.50153 13.7525C3.68953 14.1465 3.91853 14.5395 4.19553 14.9405C2.99053 16.3965 2.98553 17.6345 4.16953 18.8165C5.35353 19.9985 6.59453 19.9925 8.05353 18.7875C8.45453 19.0615 8.84753 19.2885 9.24153 19.4755C9.45753 21.1725 10.3545 21.9995 11.9235 21.9995C13.5285 21.9995 14.4425 21.1505 14.6725 19.4305C15.0645 19.2415 15.4635 19.0095 15.8625 18.7395C17.3135 19.9365 18.5565 19.9325 19.7525 18.7395C20.9305 17.5645 20.9325 16.2915 19.7535 14.8575C20.0265 14.4575 20.2595 14.0595 20.4495 13.6685C22.1685 13.4395 23.0095 12.5465 23.0175 10.9475H23.0165ZM19.6565 13.0005C19.4295 13.5155 19.1125 14.0515 18.7145 14.5945C18.5725 14.7875 18.5875 15.0535 18.7505 15.2295C20.1235 16.7165 19.6485 17.4295 19.0455 18.0315C18.4155 18.6595 17.7245 19.1095 16.2335 17.7365C16.0585 17.5745 15.7935 17.5605 15.5995 17.7005C15.0585 18.0955 14.5225 18.4105 14.0045 18.6375C13.8375 18.7105 13.7225 18.8695 13.7075 19.0525C13.5685 20.6675 12.9285 20.9945 11.9415 20.9995C10.9335 20.9725 10.3325 20.6955 10.2075 19.0995C10.1925 18.9135 10.0765 18.7515 9.90553 18.6785C9.38453 18.4565 8.86453 18.1525 8.31753 17.7495C8.22853 17.6845 8.12453 17.6525 8.02153 17.6525C7.89953 17.6525 7.77853 17.6965 7.68353 17.7845C6.18053 19.1675 5.47253 18.7035 4.87653 18.1085C4.28153 17.5145 3.81653 16.8095 5.19953 15.3115C5.36253 15.1345 5.37753 14.8675 5.23453 14.6745C4.83453 14.1335 4.51853 13.5995 4.29753 13.0865C4.22453 12.9165 4.06353 12.8005 3.87853 12.7855C2.29153 12.6595 1.97553 12.0305 1.98053 11.0565C1.98553 10.0725 2.31353 9.43449 3.92653 9.29549C4.10853 9.27949 4.26753 9.16649 4.34153 8.99949C4.56853 8.48449 4.88553 7.94849 5.28353 7.40549C5.42553 7.21249 5.41053 6.94649 5.24753 6.77049C3.87453 5.28349 4.34953 4.57049 4.95253 3.96849C5.55853 3.36449 6.27353 2.88849 7.76453 4.26349C7.94053 4.42649 8.20553 4.44149 8.39853 4.29949C8.93953 3.90449 9.47553 3.58949 9.99353 3.36249C10.1605 3.28949 10.2755 3.13049 10.2905 2.94749C10.4295 1.33249 11.0695 1.00549 12.0565 1.00049C13.0465 0.973488 13.6645 1.30449 13.7905 2.90049C13.8055 3.08649 13.9215 3.24849 14.0925 3.32149C14.6135 3.54349 15.1335 3.84749 15.6805 4.25049C15.8735 4.39249 16.1385 4.37749 16.3155 4.21549C17.8195 2.83349 18.5275 3.29749 19.1225 3.89149C19.7175 4.48549 20.1825 5.19049 18.7995 6.68849C18.6365 6.86549 18.6215 7.13249 18.7645 7.32549C19.1645 7.86649 19.4805 8.40049 19.7015 8.91349C19.7745 9.08349 19.9355 9.19949 20.1205 9.21449C21.7075 9.34049 22.0235 9.96949 22.0185 10.9435C22.0135 11.9275 21.6855 12.5655 20.0725 12.7045C19.8905 12.7205 19.7305 12.8335 19.6565 13.0005Z" fill={sideBarIconColor ? sideBarIconColor : "#00ABB6"}/>
                                          </StyledSvg>:
                                          <div>{AdminIntegrationsIcon(sideBarIconColor)}</div>
                                        :navigator.name === "Events" && (colorInfo && colorInfo.company_branding && colorInfo.company_branding.show_events === 1)  ? 
                                          <div>{UserEventsIcon(sideBarIconColor)}</div>
                                          :
                                          navigator.name === "Wellness" && (colorInfo && colorInfo.company_branding && colorInfo.company_branding.show_education === 1)?
                                            <div>{UserWellnessIcon(sideBarIconColor)}</div>
                                            : null
                  }
                  {!hideContent ? <span
                    className={navigator.name === 'People' || navigator.name === 'Wellbeing' ? 'companyDashboardLabel' : ""}>{navigator.name}</span> : null}
                  {hideContent && (this.state.hoverStateAdmin === navigator.value) ? <SidebarCard width={"0px"} bottom={"0px"} left={"100px"} colour={getColor ? getColor : "#0D4270"} commonDashboard><div className="arrow">...</div><div className="name">{this.props.t(navigator.name)}</div></SidebarCard> : null}
                </span>
                <div dashboard={1} />
              </StyledLink>
            </li>
          )
      ))}
    </Navigation>
  );
  hexToRGBA = (hex, alpha) => {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  }

  showCard = (value) => {
    this.setState({
      hoverState: value
    });
  }

  showCardAdmin = (value) => {
    this.setState({
      hoverStateAdmin: value
    });
  }

  hideCard = () => {
    this.setState({
      hoverState: null
    });
  }

  hideCardAdmin = () => {
    this.setState({
      hoverStateAdmin: null
    });
  }

  renderCommonNavigation = (CurrentLocation, getColor, hideContent,sideBarIconColor) => {
    const { colorInfo, hoverState } = this.state;
    const { role } = this.props;
    let getRGBAColor;
    if (getColor) {
      getRGBAColor = this.hexToRGBA(getColor, 0.1);
    }
    return (
      <Navigation>
        {colorInfo?.company_branding?.user_dashboard ? (<li id="wellness-dashboard-nav">
          <StyledLink commonDashboard onClick={() => this.changeRoute('/portal')} onMouseEnter={() => this.showCard("portal")} onMouseLeave={() => this.hideCard()}
            active={CurrentLocation.includes('portal') ? 1 : 0} bgColor={getRGBAColor}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
            <span className="iconLinkContainer">
              <div>{UserDashboardIcon(sideBarIconColor)}</div>
              {hideContent ? null : <span>{this.props.t("Dashboard")}</span>}
            </span>
            <div dashboard={1} active={CurrentLocation.includes('portal') ? 1 : 0} />
          </StyledLink>
        </li>):null}
        {hideContent && (hoverState === "portal") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Dashboard")}</div></SidebarCard> : null}
        {colorInfo?.company_branding?.show_challenge ? <li id="challenges-nav">
          <StyledLink commonDashboard onClick={() => this.changeRoute('/challenges')} onMouseEnter={() => this.showCard("challenges")} onMouseLeave={() => this.hideCard()}
            active={CurrentLocation.includes('challenges') ? 1 : 0} bgColor={getRGBAColor}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
            <span className="iconLinkContainer">
              <div>{UserChallengeIcon(sideBarIconColor)}</div>
              {hideContent ? null : <span>{this.props.t("Challenges")}</span>}
            </span>
            <div dashboard={1} active={CurrentLocation.includes('challenges') ? 1 : 0} />
          </StyledLink>
        </li>:null}
        {hideContent && (hoverState === "challenges") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Challenges")}</div></SidebarCard> : null}
        {colorInfo?.company_branding?.social_feed ? <li id="newsFeed-nav">
          <StyledLink commonDashboard onClick={() => this.changeRoute('/social')} onMouseEnter={() => this.showCard("social")} onMouseLeave={() => this.hideCard()}
            active={CurrentLocation.includes('social') ? 1 : 0} bgColor={getRGBAColor}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
            <span className="iconLinkContainer">
              <div>{UserSocialFeedIcon(sideBarIconColor)}</div>
              {hideContent ? null : <span>{this.props.t("Social Feed")}</span>}
            </span>
            <div dashboard={1} active={CurrentLocation.includes('social') ? 1 : 0} />
          </StyledLink>
        </li>:null}
        {hideContent && (hoverState === "social") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Social Feed")}</div></SidebarCard> : null}
        {((role === 'ADMIN') || (colorInfo.company_branding && colorInfo.company_branding.show_education === 1)) ?
          <li id="adventures-nav">
            <StyledLink commonDashboard onClick={() => this.changeRoute('/education/adventure')} onMouseEnter={() => this.showCard("wellness")} onMouseLeave={() => this.hideCard()}
              active={CurrentLocation.includes('education') ||CurrentLocation.includes('wellness-resource') ? 1 : 0} bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
              <span className="iconLinkContainer">
                <div>{UserWellnessIcon(sideBarIconColor)}</div>
                {hideContent ? null : <span>{this.props.t("Wellness")}</span>}
              </span>
              <div dashboard={1} active={CurrentLocation.includes('education') ? 1 : 0} />
            </StyledLink>
          </li>:null}
        {hideContent && (hoverState === "wellness") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Wellness")}</div></SidebarCard> : null}
        {((role === 'ADMIN') || (colorInfo?.company_branding?.show_employee_directory === 1 && colorInfo.company_branding.social_feed === 1)) ?
          <li id="employeeDirectory-nav">
            <StyledLink commonDashboard onClick={() => this.changeRoute('/community')} onMouseEnter={() => this.showCard("community")} onMouseLeave={() => this.hideCard()}
              active={CurrentLocation.includes('community') ? 1 : 0} bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0} marginLeft={1}>
              <span className="iconLinkContainer">
                <div>{UserCommunityIcon(sideBarIconColor)}</div>
                {hideContent ? null : <span>{this.props.t("Community")}</span>}
              </span>
              <div dashboard={1} active={CurrentLocation.includes('community') ? 1 : 0} />
            </StyledLink>
          </li>:null}
        {hideContent && (hoverState === "community") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Community")}</div></SidebarCard> : null}
        {((role === 'ADMIN') || (colorInfo?.company_branding?.leaderboard)) ?
          <li id="employeeDirectory-nav">
            <StyledLink commonDashboard onClick={() => this.changeRoute('/leaderboard')} onMouseEnter={() => this.showCard("leaderboard")} onMouseLeave={() => this.hideCard()}
              active={CurrentLocation.includes('leaderboard') ? 1 : 0} bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0} marginLeft={1}>
              <span className="iconLinkContainer">
                <div>{UserLeaderBoardIcon(sideBarIconColor)}</div>
                {hideContent ? null : <span>{this.props.t("Leaderboard")}</span>}
              </span>
              <div dashboard={1} active={CurrentLocation.includes('leaderboard') ? 1 : 0} />
            </StyledLink>
          </li>:null}
        {hideContent && (hoverState === "leaderboard") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Leaderboard")}</div></SidebarCard> : null}
        {((role === 'ADMIN') || (colorInfo && colorInfo.company_branding && colorInfo.company_branding.show_events === 1)) &&
          <li id="events-nav">
            <StyledLink commonDashboard onClick={() => this.changeRoute('/events')} onMouseEnter={() => this.showCard("events")} onMouseLeave={() => this.hideCard()}
              active={CurrentLocation.includes('events') ? 1 : 0} bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
              <span className="iconLinkContainer">{UserEventsIcon(sideBarIconColor)}
                {hideContent ? null : <span>{this.props.t("Events")}</span>}
              </span>
              <div dashboard={1} active={CurrentLocation.includes('events') ? 1 : 0} />
            </StyledLink>
          </li>}
        {hideContent && (hoverState === "events") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Events")}</div></SidebarCard> : null}
        {((role === 'ADMIN') || (colorInfo?.company_branding?.rewards === 1)) ?
          <li id="rewards-nav">
            <StyledLink commonDashboard onClick={() => this.changeRoute('/rewards')} onMouseEnter={() => this.showCard("rewards")} onMouseLeave={() => this.hideCard()}
              active={CurrentLocation.includes('rewards') ? 1 : 0} bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
              <span className="iconLinkContainer">
                <div>
                  {UserRewardsIcon(sideBarIconColor)}
                </div>
                {hideContent ? null : <span>{this.props.t("Rewards")}</span>}
              </span>
              <div dashboard={1} active={CurrentLocation.includes('rewards') ? 1 : 0} />
            </StyledLink>
          </li>:null}
        {hideContent && (hoverState === "rewards") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Rewards")}</div></SidebarCard> : null}
        <li id="settings-nav">
          <StyledLink commonDashboard onClick={() => this.changeRoute('/settings')} onMouseEnter={() => this.showCard("settings")} onMouseLeave={() => this.hideCard()}
            active={CurrentLocation.includes('settings') ? 1 : 0} bgColor={getRGBAColor}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
            <span className="iconLinkContainer">
              <div>{UserSettingsIcon(sideBarIconColor)}</div>
              {hideContent ? null : <span>{this.props.t("Settings")}</span>}
            </span>
            <div dashboard={1} active={CurrentLocation.includes('rewards') ? 1 : 0} />
          </StyledLink>
        </li>
        {hideContent && (hoverState === "settings") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("Settings")}</div></SidebarCard> : null}
        {(process.env.ENVIRONMENT != "production"&&process.env.ENVIRONMENT != "sandbox")&&<li id="node-nav">
          <StyledLink commonDashboard onClick={() => this.changeRoute('/node')} onMouseEnter={() => this.showCard("node")} onMouseLeave={() => this.hideCard()}
            active={CurrentLocation.includes('node') ? 1 : 0} bgColor={getRGBAColor}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}>
            <span className="iconLinkContainer">
              <div>{UserSettingsIcon(sideBarIconColor)}</div>
              {hideContent ? null : <span>{this.props.t("node")}</span>}
            </span>
            <div dashboard={1} active={CurrentLocation.includes('rewards') ? 1 : 0} />
          </StyledLink>
        </li>}
        {hideContent && (hoverState === "node") ? <SidebarCard commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t("node")}</div></SidebarCard> : null}
      </Navigation>
    )
  };

  applyOpacityToColor(color, opacity) {
    if (!color) return `rgba(11, 65, 112, ${opacity})`;
  
    if (color.startsWith('#')) {
      // Convert hex to RGB
      const hex = color.replace('#', '');
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
  
    if (color.startsWith('rgb(')) {
      return color.replace('rgb(', 'rgba(').replace(')', `, ${opacity})`);
    }
  
    return color; // fallback to original if unknown format
  }
  

  render() {
    const { response, networkError, pathValue, reward, hideContent, colorInfo2 } = this.props;
    if ((!response || !reward) && !networkError) {
      return <Loading />
    }
    if (isUndefined(colorInfo2) || isNull(colorInfo2)) {
      return <Waiting />
    }
    const { showSideBarMenu, colorInfo } = this.state;
    const CurrentLocation = pathValue;
    const Visibility = hideContent;
    // const trainingCompleted = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    let navIndex = colorInfo && colorInfo.color_branding && colorInfo.color_branding.length > 0 ? colorInfo.color_branding.findIndex((data) => data.custom_name === 'side_menu_color') : -1;
    let getColor = navIndex !== -1 && colorInfo?.color_branding[navIndex]?.color_code;

    let sideBarIconColor = this.applyOpacityToColor(getColor || 'rgb(11, 65, 112)', 0.5);
    return (
      <SidebarGrid color={getColor || 'rgb(11, 65, 112)'} hideContent={hideContent ? 1 : 0}>
        <HamBurgerContainer onClick={this.showSideBarMenuOptions} showCompany={CurrentLocation.includes('company')}>
          <i className="fa fa-bars" />
        </HamBurgerContainer>
        <MainSideBarLinks smallDevices>
          {showSideBarMenu && this.renderNavigation(CurrentLocation, getColor, Visibility, colorInfo2,sideBarIconColor)}
        </MainSideBarLinks>
        <MainSideBarLinks>
          {this.renderNavigation(CurrentLocation, getColor, Visibility, colorInfo2,sideBarIconColor)}
        </MainSideBarLinks>
      </SidebarGrid>
    );
  }
}

SideBarV3.propTypes = {
  history: PropTypes.object.isRequired,
  response: PropTypes.object,
  networkError: PropTypes.string,
  uploadProfile: PropTypes.func.isRequired,
  pathValue: PropTypes.string.isRequired,
  fetchRewardPoints: PropTypes.func.isRequired,
  reward: PropTypes.object,
  showReportTab: PropTypes.bool,
  role: PropTypes.string,
  userPermissions: PropTypes.array,
  colorData: PropTypes.object,
  hideContent: PropTypes.bool,
  hideTab: PropTypes.object,
  colorInformation: PropTypes.object,
  fetchCompanyBrandingDetails: PropTypes.func.isRequired,
  currentCompanyId: PropTypes.number,
  colorInfo2: PropTypes.object,
  t: PropTypes.func,
  billingTabStatus: PropTypes.number,
  userCompany: PropTypes.object
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  showReportTab: state.companyDashboard.showReportTab,
  colorInfo2: state.wellnessDashboard.companyBrandingDetails,
  billingTabStatus: state.stripeData.billingTabStatus,
  hideTab: state.wellnessDashboard.companyBrandingDetails,
  userCompany: state.profileData.userCompany,
 
});

const mapDispatchToProps = (dispatch) => ({
  uploadProfile: (profile) => dispatch(uploadProfile(profile)),
  fetchRewardPoints: () => dispatch(getRewardPoints()),
  fetchCompanyBrandingDetails: (id) => dispatch(getCompanyBrandingDetails(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SideBarV3));
